import { useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Componentes de ventas
import PuntoVenta from "./components/PuntoVenta";
import ListaVentas from "./components/ListaVentas";
import Clientes from "./components/Clientes";
import Productos from "./components/Productos";
import Reportes from "./components/Reportes";

import { useMaterialUIController } from "context";

export default function Ventas() {
  const [controller] = useMaterialUIController();
  const { sidenavColor, selectedCompanyId } = controller;
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const renderContent = () => {
    switch (tabValue) {
      case 0:
        return <PuntoVenta companyId={selectedCompanyId} />;
      case 1:
        return <ListaVentas companyId={selectedCompanyId} />;
      case 2:
        return <Clientes companyId={selectedCompanyId} />;
      case 3:
        return <Productos companyId={selectedCompanyId} />;
      case 4:
        return <Reportes companyId={selectedCompanyId} />;
      default:
        return <PuntoVenta companyId={selectedCompanyId} />;
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Módulo de Ventas y Facturación
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <Tabs
                  value={tabValue}
                  onChange={handleTabChange}
                  sx={{ px: 3 }}
                  variant="scrollable"
                  scrollButtons="auto"
                >
                  <Tab
                    label="Punto de Venta"
                    icon={<Icon>point_of_sale</Icon>}
                    iconPosition="start"
                  />
                  <Tab
                    label="Lista de Ventas"
                    icon={<Icon>receipt_long</Icon>}
                    iconPosition="start"
                  />
                  <Tab label="Clientes" icon={<Icon>people</Icon>} iconPosition="start" />
                  <Tab label="Productos" icon={<Icon>inventory</Icon>} iconPosition="start" />
                  <Tab label="Reportes" icon={<Icon>analytics</Icon>} iconPosition="start" />
                </Tabs>
              </MDBox>
              <MDBox p={3}>{renderContent()}</MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
